import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

const InvoiceVolumePage = ({ data, onUpdate }) => {
  const [invoiceVolume, setInvoiceVolume] = useState(data.invoiceVolume || "");
  const [fieldErrors, setFieldErrors] = useState({
    invoiceVolume: ''
  });

  // Update parent component when data changes
  useEffect(() => {
    onUpdate({
      invoiceVolume
    });
  }, [invoiceVolume]);

  // Handle volume selection
  const handleVolumeChange = (volume) => {
    setInvoiceVolume(volume);
    setFieldErrors(prev => ({
      ...prev,
      invoiceVolume: ''
    }));
    
    // Scroll to the Next button after selection
    setTimeout(() => {
      scrollTo('wizard-navigation');
    }, 100);
  };

  const scrollTo = (id) => {
    const element = document.getElementById(id);
    if (element) {
      // Scroll to the element with some offset from the top
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'nearest'
      });
    }
  };

  const volumeOptions = [
    {
      id: 'less-than-100',
      value: '<100',
      label: 'Less than 100',
      description: 'Small volume processing'
    },
    {
      id: '100-1000',
      value: '100-1000',
      label: '100 - 1,000',
      description: 'Medium volume processing'
    },
    {
      id: 'more-than-1000',
      value: '>1000',
      label: 'More than 1,000',
      description: 'High volume processing'
    },
    {
      id: 'dont-know',
      value: 'dont-know',
      label: 'I don\'t know',
      description: 'We can help you determine the right setup'
    }
  ];

  return (
    <div className="wizard-page invoice-volume-page">
      <div className="page-header">
        <h2>How many <b><u>incoming and outgoing</u></b> invoices will you process <b><u>every month</u></b>?</h2>
        {data.companyCount && data.companyCount > 1 ? <p>Please specify the <b><u>total count</u></b> for all {data.companyCount} companies.</p> : ""}
        <p>This helps us understand your needs and recommend the optimal configuration. You will always be able to change this later.</p>
      </div>

      <div className="form-content" id="invoice-volume-form">
        <div className="form-group">
          <div className="volume-options">
            {volumeOptions.map(option => (
              <div key={option.id} className="volume-option">
                <input
                  type="radio"
                  id={option.id}
                  name="invoiceVolume"
                  value={option.value}
                  checked={invoiceVolume === option.value}
                  onChange={() => handleVolumeChange(option.value)}
                  className="volume-radio"
                />
                <label htmlFor={option.id} className="volume-label">
                  <div className="volume-content">
                    <div className="volume-title">{option.label}</div>
                    <div className="volume-description">{option.description}</div>
                  </div>
                </label>
              </div>
            ))}
          </div>

          {fieldErrors.invoiceVolume && (
            <span className="field-error">{fieldErrors.invoiceVolume}</span>
          )}
        </div>
      </div>
    </div>
  );
};

InvoiceVolumePage.propTypes = {
  data: PropTypes.shape({
    companyCount: PropTypes.string,
    invoiceVolume: PropTypes.string
  }).isRequired,
  onUpdate: PropTypes.func.isRequired
};

export default InvoiceVolumePage;
